import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { FDTextInput } from '@facet-wealth/design';
import {
  _stringMetaFieldShowRemainingCharacters,
} from 'Components/UI/Meta/MetaControl/Types/String';

export default buildFacetDesignOverride()
  .nameOverride('content', {
    _component: () => FDTextInput,
    _customProps: { rows: 10 },
    [_stringMetaFieldShowRemainingCharacters]: true,
  });
